import { render, staticRenderFns } from "./StatisticsTransactions.vue?vue&type=template&id=8d5a2b26&scoped=true&"
import script from "./StatisticsTransactions.vue?vue&type=script&lang=js&"
export * from "./StatisticsTransactions.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsTransactions.vue?vue&type=style&index=0&id=8d5a2b26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d5a2b26",
  null
  
)

export default component.exports